var render, staticRenderFns
import script from "./gscAuthorizationForm.vue?vue&type=script&lang=js"
export * from "./gscAuthorizationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe994c6",
  null
  
)

export default component.exports